import React, {useEffect, useMemo} from 'react';
import {getPathWss} from "../../service/util.service";
import useWebSocket from "react-use-websocket";
import * as Auth from "../../service/auth.service";

const TestGroupWS = () => {
    const socketUrl = useMemo(() => {
        return `${getPathWss(
            window.__RUNTIME_CONFIG__.REACT_APP_COMMENT_CENTER_WS
        )}/?id=${Auth.getUserData()?.id}`
    }, []);

    const {
        sendMessage,
        sendJsonMessage,
        lastMessage,
        lastJsonMessage,
        readyState,
        getWebSocket,
    } = useWebSocket(socketUrl, {
        onOpen: () => console.log('opened'),
        onClose: () => console.log("closed"),
        //Will attempt to reconnect on all close events, such as server shutting down
        shouldReconnect: (closeEvent) => true,
    });

    useEffect(() => {
        console.log("lastJsonMessage", lastJsonMessage)
    }, [lastJsonMessage])

    return <div></div>
}

export default TestGroupWS;